import { useEffect, useRef } from 'react'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import InquiryTable from '../components/InquiryTable'

const Inquiries = () => {
  const auth = getAuth()
  const navigate = useNavigate()
  const isMounted = useRef(true)

  useEffect(() => {
    if (isMounted) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
        } else {
          navigate('/sign-in')
        }
        return () => {
          isMounted.current = false
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted])

  return (
    <div>
      <InquiryTable />
    </div>
  )
}

export default Inquiries
